import { initProductInstallation } from '../../../snippets/product-installation/product-installation';

export const initProductSmartPlugInstallation = () => {
  window.onReady(() => {
    initProductInstallation();
  });
};
